module.exports = __webpack_public_path__ + "img/2.a9a5b859.webp";